/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDealerDetailsHeader_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsStats_user$ref: FragmentReference;
export type PdpSharedDealerDetailsStats_user = {|
  +$fragmentRefs: PdpSharedDealerDetailsHeader_user$ref,
  +$refType: PdpSharedDealerDetailsStats_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsStats_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd1f13dad37cc764010ddedd665f95c1d';
module.exports = node;
